import { LegalEntityEnum } from '../legal-entity.enum';
import { CaseImageType } from './case-image-type.enum';
import { ProductMainGroups } from './product-main-group.enum';

export const IMAGE_UPLOAD_REQUIRED_LEGAL_ENTITIES: Set<LegalEntityEnum> = new Set([
  LegalEntityEnum.ON_AG,
  LegalEntityEnum.ON_UK,
  LegalEntityEnum.ON_CH,
]);

export const REQUIRED_WARRANTY_IMAGE_TYPES: Record<ProductMainGroups, CaseImageType[]> = {
  [ProductMainGroups.shoes]: [CaseImageType.SolesShoe, CaseImageType.InnerTagShoe, CaseImageType.DefectShoes],
  [ProductMainGroups.apparel]: [CaseImageType.InnerTagApparel, CaseImageType.DefectApparel],
  [ProductMainGroups.accessories]: [CaseImageType.InnerTagAccessories, CaseImageType.DefectAccessories],
};
